"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitConfig = void 0;
/**
 * Created by Ning Jiang on 11/13/2017.
 */
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
class NolimitConfig {
    static get instance() {
        if (!this._instance) {
            this._instance = new NolimitConfig();
        }
        return this._instance;
    }
    static get isDevMode() {
        return NolimitConfig.instance._isDevMode;
    }
    static get forceCanvas() {
        return NolimitConfig.instance._forceCanvas;
    }
    constructor() {
        if (NolimitConfig._instance) {
            throw new Error("NolimitConfig.constructor() - Instantiation failed: Singleton.");
        }
        try {
            this._isDevMode = (window.sessionStorage.getItem("nolimit.development") === "true") || false;
        }
        catch (e) {
            Logger_1.Logger.log("Internal Error: dev state is not valid! Force off!");
            this._isDevMode = false;
        }
        try {
            this._forceCanvas = window["nolimit"].options.forceCanvas || false;
        }
        catch (e) {
            Logger_1.Logger.log("Internal Error: forceCanvas state is not valid! Force off!");
            this._forceCanvas = false;
        }
    }
}
exports.NolimitConfig = NolimitConfig;
//# sourceMappingURL=NolimitConfig.js.map